import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const EMPTY = { current: "", next: "", confirm: "" };
const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e?.msg).join(" ") : "Cambio password non riuscito");

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return setError("La nuova password deve avere almeno 8 caratteri.");
    if (f.next !== f.confirm) return setError("Le due nuove password non coincidono.");
    setBusy(true); setError("");
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password aggiornata. Usa la nuova password al prossimo accesso.");
      setOpen(false); setF(EMPTY);
    } catch (err) {
      setError(errText(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const field = (k, label, testid, auto) => (
    <div className="space-y-1.5">
      <Label htmlFor={testid}>{label}</Label>
      <Input id={testid} data-testid={testid} type="password" autoComplete={auto} value={f[k]} onChange={set(k)} required />
    </div>
  );

  return (
    <>
      <button onClick={() => { setOpen(true); setError(""); }} data-testid="admin-change-password"
        className="inline-flex items-center gap-2 text-sm text-[#8C7F78] hover:text-[#2D2825]">
        <KeyRound size={16} /> <span className="hidden sm:inline">Cambia password</span>
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setF(EMPTY); }}>
        <DialogContent className="max-w-md" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">Cambia password</DialogTitle>
            <DialogDescription>Scegli una nuova password di almeno 8 caratteri. Resterai connessa.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            {field("current", "Password attuale", "cp-current", "current-password")}
            {field("next", "Nuova password", "cp-new", "new-password")}
            {field("confirm", "Conferma nuova password", "cp-confirm", "new-password")}
            {error && <div className="text-sm text-[#B85750]" data-testid="cp-error">{error}</div>}
            <Button type="submit" disabled={busy} data-testid="cp-submit" className="w-full rounded-full bg-[#2D2825] hover:bg-[#473f3a]">
              {busy ? <Loader2 className="animate-spin" size={16} /> : "Salva nuova password"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
